import { StateSchema } from 'app/providers/StoreProvider';

import { UserRole, acceptableRolesForApp } from '../consts/userConsts';
import { isReOpsEmail } from '../lib/isReOpsEmail';

export const getUserData = (state: StateSchema) => state.user.userData;
export const getUserIsAuthed = (state: StateSchema) => state.user.isAuthed;
export const getUserInited = (state: StateSchema) => state.user._inited;
export const getUserRole = (state: StateSchema) => state.user.userData?.groups;
export const getUserHasPMCId = (state: StateSchema) =>
    Boolean(state.user.userData?.pmcId);

export const getUserPmcName = (state: StateSchema) =>
    state.user.userData?.pmcName;

export const getProfileIsLoading = (state: StateSchema) =>
    state.user.isProfileLoading;

export const getAuthIsLoading = (state: StateSchema) =>
    state.user.isAuthLoading;

export const getUserRoleIsAcceptable = (state: StateSchema) =>
    acceptableRolesForApp.includes(state.user.userData?.groups);

export const getUserIsMaintenanceTechnician = (state: StateSchema) =>
    state.user.userData?.groups.includes(UserRole.MAINTENANCE_TECHNICIAN);

export const getIsReOpsUser = (state: StateSchema) =>
    isReOpsEmail(state.user.userData?.email);

export const getUserCanManageInOrderSavingsSettings = (state: StateSchema) => {
    const currentUserRole = getUserRole(state);

    return currentUserRole === UserRole.PMC_ADMIN && getIsReOpsUser(state);
};
